import { persistReducer } from "redux-persist";
import { authReducer } from "../auth";
import { authPersistConfig } from "./config";

export const authPersistedReducer = persistReducer(
  authPersistConfig,
  authReducer
);
